<template>
  <section class="dashboard-view">
    <div class="page-head">
      <div><h2>工作台</h2><p>欢迎回来，今天是 {{ todayLabel }}</p></div>
      <div><el-button icon="el-icon-download" @click="exportReport">导出报告</el-button><el-button type="success" icon="el-icon-refresh" @click="refresh">刷新数据</el-button></div>
    </div>
    <el-row :gutter="16"><el-col v-for="item in stats" :key="item.label" :xs="12" :sm="8" :lg="4"><el-card class="stat-card"><small>{{ item.label }}</small><strong>{{ item.value }}</strong><span>{{ item.desc }}</span></el-card></el-col></el-row>
    <el-row :gutter="20" class="dashboard-panels">
      <el-col :xs="24" :lg="12"><el-card><div class="panel-title"><h3>待办事项列表</h3><el-button type="text" @click="$router.push('/leaves')">管理全部 <i class="el-icon-arrow-right" /></el-button></div><div v-for="item in todos" :key="item.title" class="todo-item" @click="$router.push(item.path)"><i :class="item.icon" /><div><b>{{ item.title }}</b><small>{{ item.meta }}</small></div><i class="el-icon-arrow-right" /></div></el-card></el-col>
      <el-col :xs="24" :lg="12"><el-card><div class="panel-title"><h3>最新通知</h3><el-button type="text" @click="$router.push('/notices')">查看全部 <i class="el-icon-arrow-right" /></el-button></div><div class="notice-list"><article v-for="item in notices" :key="item.title" @click="$router.push('/notices')"><el-tag size="mini">{{ item.type }}</el-tag><b>{{ item.title }}</b><p>{{ item.content }}</p></article></div></el-card></el-col>
    </el-row>
  </section>
</template>

<script>
import { getSummary } from '../../api/dashboard'
import { listNotices } from '../../api/operations'
import { getSettings } from '../../api/settings'
import { formatMoney } from '../../utils/format'

const noticeTypeLabels = { organization: '机构公告', class: '班级通知', payment: '缴费通知', activity: '活动通知', holiday: '放假通知' }

export default {
  name: 'Dashboard',
  data: () => ({ stats: [], todos: [], notices: [] }),
  computed: {
    todayLabel() { return new Date().toLocaleDateString('zh-CN', { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' }) }
  },
  created() { this.refresh(false) },
  methods: {
    exportReport() {
      const csv = ['指标,数值,说明', ...this.stats.map(item => `${item.label},${item.value},${item.desc}`)].join('\n')
      const blob = new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '工作台报告.csv'
      link.click()
      URL.revokeObjectURL(link.href)
    },
    async refresh(notify = true) {
      try {
        const [summary, noticeResult, settings] = await Promise.all([getSummary(), listNotices({ status: 'published', pageSize: 2 }), getSettings()])
        const attendance = summary.attendance
        const todo = summary.todo
        this.stats = [
          { label: '今日应到', value: attendance.expected, desc: '今日全部在读学生' },
          { label: '已签到', value: attendance.checkedIn, desc: `${attendance.expected ? Math.round(attendance.checkedIn / attendance.expected * 100) : 0}% 出勤率` },
          { label: '请假人数', value: attendance.leave, desc: '已同步审批' },
          { label: '未到人数', value: attendance.notArrived, desc: '需重点关注' },
          { label: '待审批请假', value: todo.pendingLeaveRequests, desc: '需要及时处理' }
        ]
        this.todos = [
          { title: `有 ${todo.pendingLeaveRequests} 位学生的请假申请待审核`, meta: '请假审批', path: '/leaves', icon: 'el-icon-document-checked' },
          { title: `还有 ${todo.unfilledFeedbacks} 位学生今日未填写反馈`, meta: '作业反馈', path: '/feedbacks', icon: 'el-icon-edit-outline' }
        ]
        if (settings.paymentEnabled) {
          this.stats.push({ label: '待收款', value: formatMoney(summary.finance.pendingAmount), desc: '当前累计' })
          this.todos.push({ title: `有 ${todo.pendingPayments} 笔费用待收款`, meta: '收费管理', path: '/payments', icon: 'el-icon-money' })
        }
        this.notices = (noticeResult.list || []).map(item => ({ type: noticeTypeLabels[item.type] || item.type || '机构公告', title: item.title, content: item.content || '' }))
        if (notify) this.$message.success('数据已刷新')
      } catch (error) {
        this.$message.error(error.userMessage || '工作台数据加载失败')
      }
    }
  }
}
</script>
